import React, { Component } from 'react';

class FormGroup extends Component {
  constructor(props) {
    super(props);

    this.state = {
      errors: null,
    };
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ errors: nextProps.errors });
  }

  render() {
    return (
      <div className={`${this.props.className} ${this.state.errors !== null && this.state.errors[this.props.name] ? 'has-error' : ''}`}>
        {this.props.children}
        {this.state.errors !== null && this.state.errors[this.props.name] ? (
          <p className="help-block text-left u-mb-0">
            {this.state.errors[this.props.name].map(text => <div key={text}>{text}</div>)}
          </p>
        ) : null}
      </div>
    );
  }
}

FormGroup.defaultProps = {
  className: 'col-md-6 form-group',
};

export default FormGroup;



// WEBPACK FOOTER //
// ./src/components/FormGroup.js